module.exports = __webpack_public_path__ + "static/media/DMC.22b0e2e9.webm";